<style lang="scss" scoped>
  .login-page{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:url('../img/admin/login-bg.jpg') no-repeat center top #000;
  }
  .login-template{
    width:340px;
    margin:0 auto;
    text-align:center;
    .logo{
      padding:40px 0;
      img{
        max-width:50%;
      }
    }
    .contents{
      background:#fff;
      padding:40px;
      border-radius: 10px;
    }
    .default-btn{
      width:100%;
      display:block;
      padding:10px 0;
      text-align:center;
      background:#006a92;
      color:#fff;
      font-size:12px;
      border-radius: 5px;
    }
  }
  .contents{
  .default-input{
      display: block;
      width:100%;
      padding: 0 10px;
      text-align: center;
      color: #000;
      font-size: 12px;
      border-radius: 5px;
      border:1px solid #ccc;
      height:37px;
      text-align:left;
      margin-bottom:10px;
    }
    .notice{
      font-size:12px;
      color:#ccc;
      text-align:left;
      padding:5px 0 10px 0;
    }
  }
  @media (min-width: 1300px) {
    .login-template{
      .logo{
        padding:200px 0 40px 0;
        img{
          max-width:100%;
        }
      }
      .contents{
        background:#fff;
        padding:40px;
        border-radius: 10px;
      }
      .default-btn{
        padding:11px 0;
        font-size:20px;
      }
    }
    .contents{
      .default-input{
        height:50px;
        font-size:20px;
      }
    }
  }
</style>
<template>
  <div class="login-page">
      <div class="login-template">
        <h1 class="logo">
          <img src="../img/admin/white-logo.png" alt="땡처리 부동산 닷컴">
        </h1>
        <div class="contents">
          <input type="text" class="default-input" placeholder="ID를 입력해주세요." v-model="id">
          <input type="password" class="default-input" placeholder="패스워드를 입력해주세요." v-model="pw" v-on:keyup.enter="adminLogin">
          <div class="phone-input-area" v-if="phoneNumberInput">
            <button type="button" class="default-btn login-btn" @click="adminLogin()">로그인</button>
          </div>
        </div>
      </div>
      <form name="form1"  method="post">
      </form>
  </div>
</template>
<script>

export default {
  name: 'AdminLogin',
  data () {
    return {
      id: '',
      pw: '',
      phoneNumber: '',
      phoneNumberInput: true,
      certification: false,
      certificationNumber: '',
      userId: '123'
    }
  },
  mounted () {
    window.onpopstate = event => {
      if (sessionStorage.getItem('token') !== null && this.$route.path === '/Adminlogin') {
        this.$router.push('/')
      }
    }
  },
  methods: {
    adminLogin: function () {
      const params = {
        'idManager': this.id,
        'pwManager': this.pw,
        'flag': 'ADMIN'
      }
      this.$store.dispatch('apiMemInfo', params)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/AdminLogin.vue